// Strength page (.tp-strength) — guarded so it only runs on page-strength.php.
// FAQ accordion (single-open) + smooth in-page anchors. The mobile burger is
// handled by default-page.js (shared .tp-default header). The +/- sign is CSS
// (.st-faq-sign__v toggles with .is-open), so JS only toggles state + height.
document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.tp-strength');
    if (!root) {
        return;
    }

    var faqItems = Array.prototype.slice.call(root.querySelectorAll('.st-faq-item'));

    function setFaq(item, open) {
        var panel = item.querySelector('.st-faq-panel');
        var btn = item.querySelector('.st-faq-q');
        item.classList.toggle('is-open', open);
        if (panel) {
            panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
        }
        if (btn) {
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
    }

    faqItems.forEach(function (item) {
        var btn = item.querySelector('.st-faq-q');
        if (!btn) {
            return;
        }
        if (item.classList.contains('is-open')) {
            setFaq(item, true);
        }
        btn.addEventListener('click', function () {
            var willOpen = !item.classList.contains('is-open');
            faqItems.forEach(function (other) {
                if (other !== item) {
                    setFaq(other, false);
                }
            });
            setFaq(item, willOpen);
        });
    });

    // ── Programs accordion (mobile only) ──
    // Desktop shows every card in the grid; under 600px the card header becomes
    // a single-open accordion toggle (first card open by default).
    var progItems = Array.prototype.slice.call(root.querySelectorAll('.st-prog'));
    var progMq = window.matchMedia('(max-width: 600px)');

    function setProg(item, open) {
        var panel = item.querySelector('.st-prog__panel');
        var btn = item.querySelector('.st-prog__head');
        item.classList.toggle('is-open', open);
        if (btn) {
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        if (panel) {
            panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
        }
    }

    function applyProgMode(mq) {
        progItems.forEach(function (item, idx) {
            if (mq.matches) {
                setProg(item, idx === 0);
            } else {
                var panel = item.querySelector('.st-prog__panel');
                var btn = item.querySelector('.st-prog__head');
                item.classList.remove('is-open');
                if (panel) { panel.style.maxHeight = ''; }
                if (btn) { btn.setAttribute('aria-expanded', 'false'); }
            }
        });
    }

    progItems.forEach(function (item) {
        var btn = item.querySelector('.st-prog__head');
        if (!btn) {
            return;
        }
        btn.addEventListener('click', function () {
            if (!progMq.matches) {
                return;
            }
            var willOpen = !item.classList.contains('is-open');
            progItems.forEach(function (other) {
                if (other !== item) {
                    setProg(other, false);
                }
            });
            setProg(item, willOpen);
        });
    });

    if (progItems.length) {
        applyProgMode(progMq);
        if (progMq.addEventListener) {
            progMq.addEventListener('change', applyProgMode);
        } else if (progMq.addListener) {
            progMq.addListener(applyProgMode);
        }
    }

    // ── Smooth scroll for in-page anchors ──
    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
            var hash = link.getAttribute('href');
            if (hash.length < 2) {
                return;
            }
            var target = document.querySelector(hash);
            if (target) {
                e.preventDefault();
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            document.body.classList.remove('menu-open');
        });
    });
});
